import { clientVersion } from '@trello/config';

// hash that contains the url and maps it to the request promise
// for fetching the resource. If you mount multiple components at once,
// each of week has its own instance of an apollo hook, apollo wont
// know that you are already fetching that resource until it exists in
// the cache. Therefore, we construct this map to make sure we only
// make the request once, then remove it from the hash.
const requestHash: { [url: string]: Promise<Response> | null } = {};

export const cachedFetch = async (url: string) => {
  const requestPromise =
    requestHash[url] ||
    fetch(url, {
      credentials: 'include',
      headers: {
        'X-Trello-Client-Version': clientVersion,
      },
    });

  if (!requestHash[url]) {
    requestHash[url] = requestPromise;
  }

  const response = await requestPromise;

  // once the request finishes, remove the url from the cache
  // so the future refetches can still run
  requestHash[url] = null;

  return response.clone();
};
